export function getMarginProps(props) {
    var toUseStyle = {};
    var classes = {
        'gutter': props.gutter,
        'vertical__guttertter': props.verticalGutter,
        'horizontal__gutter': props.horizontalGutter,
    };
    Object.keys(props).filter(function (key) { return ['mr-', 'ml-', 'mb-', 'mt-', 'ma-', 'mx-', 'my-',].includes(key.substring(0, 3)); }).forEach(function (key) { return classes[key] = true; });
    if (typeof props.marginBottom !== 'undefined')
        toUseStyle.marginBottom = props.marginBottom;
    if (typeof props.marginLeft !== 'undefined')
        toUseStyle.marginLeft = props.marginLeft;
    if (typeof props.marginRight !== 'undefined')
        toUseStyle.marginRight = props.marginRight;
    if (typeof props.marginTop !== 'undefined')
        toUseStyle.marginTop = props.marginTop;
    if (typeof props.margin !== 'undefined')
        toUseStyle.margin = props.margin;
    if (typeof props.marginX !== 'undefined') {
        toUseStyle.marginLeft = props.marginX;
        toUseStyle.marginRight = props.marginX;
    }
    ;
    if (typeof props.marginY !== 'undefined') {
        toUseStyle.marginBottom = props.marginY;
        toUseStyle.marginTop = props.marginY;
    }
    ;
    return {
        classes: classes,
        props: {},
        styles: toUseStyle,
        variables: {}
    };
}
export function getPaddingProps(props) {
    var toUseStyle = {};
    var classes = {};
    Object.keys(props).filter(function (key) { return ['pr', 'pl', 'pb', 'pt', 'pa', 'px', 'py',].includes(key.substring(0, 2)); }).forEach(function (key) { return classes[key] = props[key] === true; });
    if (typeof props.paddingBottom !== 'undefined')
        toUseStyle.paddingBottom = props.paddingBottom;
    if (typeof props.paddingLeft !== 'undefined')
        toUseStyle.paddingLeft = props.paddingLeft;
    if (typeof props.paddingRight !== 'undefined')
        toUseStyle.paddingRight = props.paddingRight;
    if (typeof props.paddingTop !== 'undefined')
        toUseStyle.paddingTop = props.paddingTop;
    if (typeof props.padding !== 'undefined')
        toUseStyle.padding = props.padding;
    if (typeof props.paddingX !== 'undefined') {
        toUseStyle.paddingLeft = props.paddingX;
        toUseStyle.paddingRight = props.paddingX;
    }
    ;
    if (typeof props.paddingY !== 'undefined') {
        toUseStyle.paddingBottom = props.paddingY;
        toUseStyle.paddingTop = props.paddingY;
    }
    ;
    return {
        classes: classes,
        props: {},
        styles: toUseStyle,
        variables: {}
    };
}
